export default __webpack_public_path__ + "static/media/Create-documentation.9205fecc.md";